class HeaderDrawer extends HTMLElement {
  constructor() {
    super();
    this.details = this.querySelector('details');
    this.summary = this.querySelector('summary');
    this.content = this.querySelector('.menu-drawer');
    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.summary.addEventListener('click', this.onClick.bind(this));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;
    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;
    openDetailsElement.removeAttribute('open');
  }

  onClick(event) {
    event.preventDefault();
    const isOpen = this.details.hasAttribute('open');
    this.closeAllDrawers();
    if (!isOpen) this.details.setAttribute('open', true);
  }

  closeAllDrawers() {
    document.querySelectorAll('header-drawer details[open]').forEach((el) => {
      el.removeAttribute('open');
    });
  }
}

customElements.define('header-drawer', HeaderDrawer);
